// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"966":"7cc72ff1","1383":"da594d9f","2533":"da594d9f","3191":"da594d9f","4180":"da594d9f","4275":"7cc72ff1","5381":"da594d9f","7294":"7cc72ff1","7812":"bb22a910","8692":"bb22a910","9680":"bdc3744c"}[chunkId] + ".css";
};